
import { Component } from "react";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import Loader from "../../../../../utils/Loader";
import { ToastContainer, toast } from "react-toastify";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import { getStallDesignDetails_action, insertUpdateStallDesign_action } from '../../../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/stallDesign_action/stallDesign_action'
import $ from 'jquery'
import { toastError, toastSuccess } from "../../../../../utils/constants";
import Resizer from "react-image-file-resizer";
import { BASE_URL } from "../../../../../utils/constants";
import Modal from "react-modal";
// import Modal from "react-bootstrap/Modal";
import moment from "moment";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import ConfirmationModal from "../../../../../common_components/confirmationa_modal";
import {
  insertUpdateExhibitorContractorBadgeApplication_action,
  getExhibitorContractorBadgeApplicationDetails_action,
} from "../../../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/exhibitorContractorBadgeApllication_action/exhibitorContractorBadgeApllication_action";

class StallDesign extends Component {

  //Initialize constructor
  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      confirmationObj: { message: '', buttonName: '', action: '' },
      popArg: [],
      isOpenConfirmationModal: false,
      ExhibitorName: "",
      StallName: "",
      HallName: "",
      OpenSides: "",
      StallArea: "",
      StallTypeName: "",
      filePath_1: "",
      filePath_2: "",
      filePath_3: "",
      filePath_4: "",
      filePath_5: "",
      filePath_6: "",
      filePath_7: "",

      fileName_1: "",
      fileName_2: "",
      fileName_3: "",
      fileName_4: "",
      fileName_5: "",
      fileName_6: "",
      fileName_7: "",

      fileType_1: "",
      fileType_2: "",
      fileType_3: "",
      fileType_4: "",
      fileType_5: "",
      fileType_6: "",
      fileType_7: "",

      Remark: "",
      DeadlineDate: "",
      currentDate: moment().format("DD-MM-YYYY"),

      StallDesignFormID: null,
      FloorPlanDocument: null,
      ThreeDViewDocument: null,
      FrontViewDocument: null,
      SupportingDocument: null,
      DimentionalView: null,
      FireSafteyCertificate: null,

      displayfile_1: "",
      displayfile_2: "",
      displayfile_3: "",
      displayfile_4: "",
      displayfile_5: "",
      displayfile_6: "",
      displayfile_7: "",
      isOpen: false,

      modalImagePath: "",
      modalImageName: "",

      is_View: false,
      StatusID: "",
      isOpen2: false,
      isCollapse: false,
      isHideSection: sessionStorage.getItem("RoleIDSS") != 1 && sessionStorage.getItem("RoleIDSS") != 8,
      CompanyName: '',
      PersonName: '',
      Email: '',
      Mobile: '',
      SetUpDayPasses: '',
      DismantleDayPasses: '',

      CompanyNameErr: '',
      PersonNameErr: '',
      EmailErr: '',
      MobileErr: '',
      SetUpDayPassesErr: '',
      DismantleDayPassesErr: '',
      Is_Agree: false,
      Is_AgreeErr: '',
      ExhContractorBadgeID: '',

      isUpdateFile_1: false,
      isUpdateFile_2: false,
      isUpdateFile_3: false,
      isUpdateFile_4: false,
      isUpdateFile_5: false,
      isUpdateFile_6: false,
      isUpdateFile_7: false,

      TechnicalLayout: ''
    };

    this.handleConfirmation = this.handleConfirmation.bind(this)
  }


  handleConfirmation(flag) {
    const { confirmationObj, popArg } = this.state;
    if (flag) {
      if (confirmationObj.action == 0) {
        this.handleSubmit()
      }
    }
    this.setState({ isOpenConfirmationModal: false })
  }

  componentDidMount() {
    const VendorDetails = this.props.location.state != null ? this.props.location.state.VendorDetails
      : null;
    this.setState({
      DeadlineDate: this.props.location.state != null && this.props.location.state != "" && this.props.location.state.Deadline != "" ?
        moment(this.props.location.state.Deadline).format('DD-MM-YYYY') : '',
      is_View: this.props.location.state != null && this.props.location.state.is_View ?
        this.props.location.state.is_View : sessionStorage.getItem("RoleIDSS") != 1,
      StatusID: this.props.location.state != null && this.props.location.state.StatusID ?
        this.props.location.state.StatusID : '',
      CompanyName: VendorDetails?.CompanyName || "-",
      PersonName: VendorDetails?.PersonName || "-",
      Email: VendorDetails?.EmailID || "-",
      Mobile: VendorDetails?.MobileNo || "-",
    })
    console.log("this.props----------------->", this.props)
    this.loadscript()
    this.getStallDesignetails()
    this.getExhibitorContractorBadgeApplicationDetails()
  }

  getExhibitorContractorBadgeApplicationDetails() {
    const { } = this.state;
    this.setState({ isLoading: true });
    this.props
      .getExhibitorContractorBadgeApplicationDetails_action()
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false });
          if (data.data[0]["ExhContractorBadgeID"]) {
            this.setState({
              CompanyName: data.data[0]["CompanyName"],
              PersonName: data.data[0]["PersonName"],
              Email: data.data[0]["Email"],
              Mobile: data.data[0]["Mobile"],
              SetUpDayPasses: data.data[0]["SetUpDayPasses"],
              DismantleDayPasses: data.data[0]["DismantleDayPasses"],
              ExhContractorBadgeID: data.data[0]["ExhContractorBadgeID"],
              Remark: data.data[0]["Remark"],
              Is_Agree: data.data[0]["IsAgree"],
            });
          }
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  loadscript() {
    $(document).ready(function () {
      $(this).scrollTop(0);
    });
  }

  getStallDesignetails() {
    const { Remark, Is_Agree, isQuantity, Is_Required } = this.state
    this.setState({ isLoading: true })
    this.props
      .getStallDesignDetails_action()
      .then((data) => {
        if (data.error != 1) {

          this.setState({
            isLoading: false,
            ExhibitorName: data.data[0]['ExhibitorName'] != null ? data.data[0]['ExhibitorName'] : '-',
            StallName: data.data[0]['StallName'] != null ? data.data[0]['StallName'] : '-',
            HallName: data.data[0]['HallName'] != null ? data.data[0]['HallName'] : '-',
            OpenSides: data.data[0]['OpenSides'] != null ? data.data[0]['OpenSides'] : '-',
            StallArea: data.data[0]['StallArea'] != null ? data.data[0]['StallArea'] : '-',
            StallTypeName: data.data[0]['StallTypeName'] != null ? data.data[0]['StallTypeName'] : '-',
            FloorPlanDocument: data.data[0]['FloorPlanDocument'],
            ThreeDViewDocument: data.data[0]['ThreeDViewDocument'],
            FrontViewDocument: data.data[0]['FrontViewDocument'],
            SupportingDocument: data.data[0]['SupportingDocument'],
            DimentionalView: data.data[0]['DimentionalView'],
            TechnicalLayout: data.data[0]['TechnicalLayout'],
            FireSafteyCertificate: data.data[0]['FireSafteyCertificate'],
            StallDesignFormID: data.data[0]['StallDesignFormID'],
            Remark: data.data[0]['Remark']
          })

          const url = BASE_URL.split('/api')

          if (data.data[0]['FloorPlanDocument'] != null) {
            const file = data.data[0]['FloorPlanDocument'].split(`${data.data[0]['ExhRegistrationID']}/`)
            this.setState({ fileName_1: file[1], displayfile_1: url[0] + data.data[0]['FloorPlanDocument'] })
          }
          if (data.data[0]['ThreeDViewDocument'] != null) {
            const file = data.data[0]['ThreeDViewDocument'].split(`${data.data[0]['ExhRegistrationID']}/`)
            this.setState({ fileName_2: file[1], displayfile_2: url[0] + data.data[0]['ThreeDViewDocument'] })
          }
          if (data.data[0]['FrontViewDocument'] != null) {
            const file = data.data[0]['FrontViewDocument'].split(`${data.data[0]['ExhRegistrationID']}/`)
            this.setState({ fileName_3: file[1], displayfile_3: url[0] + data.data[0]['FrontViewDocument'] })
          }
          if (data.data[0]['SupportingDocument'] != null) {
            const file = data.data[0]['SupportingDocument'].split(`${data.data[0]['ExhRegistrationID']}/`)
            this.setState({ fileName_4: file[1], displayfile_4: url[0] + data.data[0]['SupportingDocument'] })
          }
          if (data.data[0]['DimentionalView'] != null) {
            const file = data.data[0]['DimentionalView'].split(`${data.data[0]['ExhRegistrationID']}/`)
            this.setState({ fileName_5: file[1], displayfile_5: url[0] + data.data[0]['DimentionalView'] })
          }
          if (data.data[0]['FireSafteyCertificate'] != null) {
            const file = data.data[0]['FireSafteyCertificate'].split(`${data.data[0]['ExhRegistrationID']}/`)
            this.setState({ fileName_6: file[1], displayfile_6: url[0] + data.data[0]['FireSafteyCertificate'] })
          }

          if (data.data[0]['TechnicalLayout'] != null) {
            const file = data.data[0]['TechnicalLayout'].split(`${data.data[0]['ExhRegistrationID']}/`)
            this.setState({ fileName_7: file[1], displayfile_7: url[0] + data.data[0]['TechnicalLayout'] })
          }
        }
        else {
          this.setState({ isLoading: false })
          toastError(data.msg)
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  handleSubmit() {
    const { Remark,
      filePath_1,
      filePath_2,
      filePath_3,
      filePath_4,
      filePath_5,
      filePath_6,
      filePath_7,

      fileName_1,
      fileName_2,
      fileName_3,
      fileName_4,
      fileName_5,
      fileName_6,
      fileName_7,

      fileType_1,
      fileType_2,
      fileType_3,
      fileType_4,
      fileType_5,
      fileType_6,
      fileType_7,

      StallDesignFormID,
      FloorPlanDocument,
      ThreeDViewDocument,
      FrontViewDocument,
      SupportingDocument,
      DimentionalView,
      FireSafteyCertificate,
      SetUpDayPasses,
      DismantleDayPasses,
      Is_Agree,
      isUpdateFile_1,
      isUpdateFile_2,
      isUpdateFile_3,
      isUpdateFile_4,
      isUpdateFile_5,
      isUpdateFile_6,
      isUpdateFile_7,
      TechnicalLayout
    } = this.state
    this.inputValidate()
    const ManualFormsID = this.props.location.state?.ManualFormsID || null;
    const ServiceID = this.props.location.state?.ServiceID || null;
    const VendorDetails = this.props.location.state?.VendorDetails || {};
    if (
      SetUpDayPasses != "" &&
      SetUpDayPasses != null &&
      DismantleDayPasses != "" &&
      DismantleDayPasses != null &&
      Is_Agree
    ) {
      if (fileName_1 != '' && fileName_2 != '' && fileName_3 != '' && fileName_4 != '' && fileName_7 != '') {
        this.setState({ isLoading: true })
        this.props
          .insertUpdateStallDesign_action(
            StallDesignFormID,
            FloorPlanDocument,
            ThreeDViewDocument,
            FrontViewDocument,
            SupportingDocument,
            DimentionalView,
            FireSafteyCertificate,
            TechnicalLayout,
            Remark,
            filePath_1,
            filePath_2,
            filePath_3,
            filePath_4,
            filePath_5,
            filePath_6,
            filePath_7,
            fileName_1,
            fileName_2,
            fileName_3,
            fileName_4,
            fileName_5,
            fileName_6,
            fileName_7,
            fileType_1,
            fileType_2,
            fileType_3,
            fileType_4,
            fileType_5,
            fileType_6,
            fileType_7,
            ManualFormsID, ServiceID, VendorDetails,
            isUpdateFile_1,
            isUpdateFile_2,
            isUpdateFile_3,
            isUpdateFile_4,
            isUpdateFile_5,
            isUpdateFile_6,
            isUpdateFile_7,
          )
          .then((data) => {
            if (data.error != 1) {
              this.saveContractorBadge()
            }
            else {
              this.setState({ isLoading: false })
              toastError(data.msg)
            }
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        toastError("Please Choose Mandatory File's")
        this.setState({ isLoading: false })
      }
    } else {
      toastError("Please enter mandatory fields!");
      this.setState({ isLoading: false });
    }
  }

  onFilePick = async (e, file, typeName) => {
    e.preventDefault();

    if (!file || file.length === 0) return;

    const selectedFile = file[0];

    // ✅ File size validation
    if (selectedFile.size >= 3 * 1024 * 1024) {
      toastError('File size more than 3MB is not allowed.');
      return;
    }

    const fileName = selectedFile.name.toLowerCase();

    // ✅ File type validation
    const allowedTypes = ['.jpeg', '.jpg', '.png'];
    const isValid = allowedTypes.some(ext => fileName.endsWith(ext));

    if (!isValid) {
      toast.error('Only .jpg, .jpeg, .png files are allowed', {
        position: "top-center",
        theme: 'colored',
        autoClose: 3000,
        hideProgressBar: true,
      });
      return;
    }

    // ✅ Convert file
    const image = await this.convertToBase64(selectedFile);

    // ✅ Extract index (file_1 → 1)
    const index = typeName.split('_')[1];

    // ✅ Extract file type safely
    const finalFileTypeName = selectedFile.type.includes('/')
      ? selectedFile.type.split('/')[1]
      : '';

    // ✅ SINGLE setState (important)
    this.setState({
      [`filePath_${index}`]: image,
      [`fileName_${index}`]: selectedFile.name,
      [`displayfile_${index}`]: image,
      [`fileType_${index}`]: finalFileTypeName,
      [`isUpdateFile_${index}`]: true
    });
  };

  convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {

      const reader = new FileReader()

      reader.readAsDataURL(file)

      reader.onload = () => resolve(reader.result)

      reader.onerror = error => reject(error)
    })
  }

  removeFile(e, fileType) {
    e.preventDefault()
    if (fileType == 'file_1') {
      this.setState({ FloorPlanDocument: null, fileName_1: '', filePath_1: '', fileType_1: '', displayfile_1: '', isUpdateFile_1: true })
    } else if (fileType == 'file_2') {
      this.setState({ ThreeDViewDocument: null, fileName_2: '', filePath_2: '', fileType_2: '', displayfile_2: '', isUpdateFile_2: true })
    } else if (fileType == 'file_3') {
      this.setState({ FrontViewDocument: null, fileName_3: '', filePath_3: '', fileType_3: '', displayfile_3: '', isUpdateFile_3: true })
    } else if (fileType == 'file_4') {
      this.setState({ SupportingDocument: null, fileName_4: '', filePath_4: '', fileType_4: '', displayfile_4: '', isUpdateFile_4: true })
    } else if (fileType == 'file_5') {
      this.setState({ DimentionalView: null, fileName_5: '', filePath_5: '', fileType_5: '', displayfile_5: '', isUpdateFile_5: true })
    } else if (fileType == 'file_6') {
      this.setState({ FireSafteyCertificate: null, fileName_6: '', filePath_6: '', fileType_6: '', displayfile_6: '', isUpdateFile_6: true })
    } else if (fileType == 'file_7') {
      this.setState({ TechnicalLayout: null, fileName_7: '', filePath_7: '', fileType_7: '', displayfile_7: '', isUpdateFile_7: true })
    }
  }

  handleCancel() {
    window.history.back();
  }

  showImage(typeName, name) {
    const { displayfile_1,
      displayfile_2,
      displayfile_3,
      displayfile_4,
      displayfile_5,
      displayfile_6, displayfile_7 } = this.state
    this.setState({
      isOpen: true,
    })
    if (typeName == 'file_1') {
      this.setState({ modalImagePath: displayfile_1, modalImageName: name })
    } else if (typeName == 'file_2') {
      this.setState({ modalImagePath: displayfile_2, modalImageName: name })
    } else if (typeName == 'file_3') {
      this.setState({ modalImagePath: displayfile_3, modalImageName: name })
    } else if (typeName == 'file_4') {
      this.setState({ modalImagePath: displayfile_4, modalImageName: name })
    } else if (typeName == 'file_5') {
      this.setState({ modalImagePath: displayfile_5, modalImageName: name })
    } else if (typeName == 'file_6') {
      this.setState({ modalImagePath: displayfile_6, modalImageName: name })
    } else if (typeName == 'file_7') {
      this.setState({ modalImagePath: displayfile_7, modalImageName: name })
    }
  }

  inputValidate() {
    const {
      Is_Agree,
      SetUpDayPasses,
      DismantleDayPasses,
    } = this.state;

    if (SetUpDayPasses == null || SetUpDayPasses == "") {
      this.setState({
        SetUpDayPassesErr: "Please Enter No. of Passes/Bands Required for setup days",
      });
    }
    if (DismantleDayPasses == null || DismantleDayPasses == "") {
      this.setState({
        DismantleDayPassesErr: "Please Enter No. of Passes/Bands Required for dismantle days",
      });
    }
    if (Is_Agree == 0 || Is_Agree == false) {
      this.setState({
        Is_AgreeErr: "kindly agree to Guidelines and Exhibition rules of INDIA ITME 2026",
      });
    }
  }

  saveContractorBadge() {
    const {
      CompanyName,
      PersonName,
      Address,
      Email,
      Mobile,
      LandlineNo,
      SetUpDayPasses,
      DismantleDayPasses,
      Remark,
      Is_Agree,
      ExhContractorBadgeID,
    } = this.state;
    this.inputValidate();
    this.setState({ isLoading: true });
    const ManualFormsID = this.props.location.state?.ManualFormsID || null;
    const ServiceID = this.props.location.state?.ServiceID || null;
    const VendorDetails = this.props.location.state?.VendorDetails || {};
    this.props
      .insertUpdateExhibitorContractorBadgeApplication_action(
        CompanyName,
        PersonName,
        Address,
        Email,
        Mobile,
        LandlineNo,
        SetUpDayPasses,
        DismantleDayPasses,
        Remark,
        Is_Agree,
        ExhContractorBadgeID,
        ManualFormsID,
        ServiceID,
        VendorDetails
      )
      .then((data) => {
        if (data.error != 1) {
          toastSuccess(this.state.StatusID == 0 ? 'Stall Design Form Submitted Successfully' : 'Stall Design Form Updated Successfully')
          setTimeout(() => {
            this.props.navigate('/manualForms')
          }, 2000);
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  render() {
    const { isLoading, ExhibitorName, StallName, HallName, OpenSides, StallArea, StallTypeName, Remark, currentDate, DeadlineDate,
      fileName_1,
      fileName_2,
      fileName_3,
      fileName_4,
      fileName_5,
      fileName_6,
      fileName_7,

      displayfile_1,
      displayfile_2,
      displayfile_3,
      displayfile_4,
      displayfile_5,
      displayfile_6,
      displayfile_7,
      isOpen,
      modalImagePath,
      modalImageName,
      is_View,
      StatusID,
      isOpen2,
      isCollapse,
      isHideSection, isOpenConfirmationModal,

      CompanyName,
      PersonName,
      Email,
      Mobile,
      SetUpDayPasses,
      DismantleDayPasses,

      CompanyNameErr,
      PersonNameErr,
      EmailErr,
      MobileErr,
      SetUpDayPassesErr,
      DismantleDayPassesErr,
      Is_Agree,
      Is_AgreeErr,
    } = this.state
    const isDeadlinePassed =
      DeadlineDate &&
      moment(DeadlineDate, "DD-MM-YYYY") &&
      moment(currentDate, "DD-MM-YYYY").isAfter(moment(DeadlineDate, "DD-MM-YYYY"));
    return (
      <>
        {/* {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null} */}
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {!isHideSection && (
          <>
            {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ||
              JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 8 ? (
              <ExhibitorHeader />
            ) : (
              <HeaderWithLogo />
            )}
            {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ||
              JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 8 ? (
              <ExhibitorDrawer />
            ) : (
              <AdminDrawer />
            )}
          </>
        )}
        <div className={!isHideSection ? "with-dr-container exb-top-space" : "exb-top-space"}>
          <div className="">
            {!isHideSection && (
              <div className="row">
                {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ||
                  JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 8 ? (
                  <ExhibitorTopMenu />
                ) : null}
              </div>
            )}
            <div className="row mx-2 mt-3">
              <div className="col-xl-12 p-1">
                <div className="card rounded p-0 shadow-none border">
                  <div className="card-header">
                    <h3 className="card-title d-flext" style={{ justifyContent: 'space-between' }}>
                      {" "}
                      Stall Design Approval <br />
                    </h3>
                    <a className="text-aqua"
                      target="__blank"
                      href={
                        BASE_URL.split("/api")[0] +
                        '/document/Exhibition/ManualFormGuidelines/3/boothDesignGuidelines/General_Guidelines_applicable_to_bare_Space_Construction.pdf'
                      }
                    >
                      <i className="fa fa-download" aria-hidden="true"></i> Guidelines for bare space construction

                    </a>
                  </div>
                  {!isHideSection && (
                    // <div className="card-body p-3 text-left">
                    <div className="text-left mt-2">
                      <p style={{ marginLeft: '10px' }}> <strong>Note: The section and clause numbering mentioned in this document refers to the corresponding Rules & Guidelines available in the Exhibitor Login.</strong></p>
                      <ol style={{ listStyleType: "none", paddingLeft: 0, marginLeft: 10 }}>

                        <li>
                          <strong>49.1 Stall Design & Uniformity:</strong>
                          <ul style={{ listStyleType: "none" }}>
                            <li>
                              To maintain a consistent look and enhance the overall presentation, exhibitors must adhere to the stall construction and decoration guidelines set by the organizers..
                            </li>
                          </ul>
                        </li>

                        <li>
                          <div style={{ width: "800px", margin: "10px 0" }}>
                            <strong>49.2	Stand Approval Process:</strong>
                            <table style={{ borderCollapse: "collapse" }}>
                              <thead>
                                <tr>
                                  <th style={{ background: 'none', border: "1px solid #000", padding: "8px", textAlign: "left", fontWeight: "bold" }}>
                                    Stage
                                  </th>
                                  <th style={{ background: 'none', border: "1px solid #000", padding: "8px", textAlign: "center", fontWeight: "bold" }}>
                                    Action
                                  </th>
                                  <th style={{ background: 'none', border: "1px solid #000", padding: "8px", textAlign: "center", fontWeight: "bold" }}>
                                    By Whom
                                  </th>
                                  <th style={{ background: 'none', border: "1px solid #000", padding: "8px", textAlign: "center", fontWeight: "bold" }}>
                                    Deadline
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td style={{ border: "1px solid #000", padding: "8px" }}>Design Submission</td>
                                  <td style={{ border: "1px solid #000", padding: "8px" }}>
                                    Exhibitor Submission deadline for stall designs/layouts for approval
                                  </td>
                                  <td style={{ border: "1px solid #000", padding: "8px" }}>
                                    Exhibitor / Service partner
                                  </td>
                                  <td style={{ border: "1px solid #000", padding: "8px" }}>
                                    20th September 2026
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ border: "1px solid #000", padding: "8px" }}>Final Approval</td>
                                  <td style={{ border: "1px solid #000", padding: "8px" }}>
                                    Approval of submitted designs and return to exhibitors
                                  </td>
                                  <td style={{ border: "1px solid #000", padding: "8px" }}>
                                    Official Service partner / Organiser                                  </td>
                                  <td style={{ border: "1px solid #000", padding: "8px" }}>
                                    30th September 2026.
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ border: "1px solid #000", padding: "8px" }}>On-Site Inspection</td>
                                  <td style={{ border: "1px solid #000", padding: "8px" }}>
                                    Stand inspected during and after construction                                  </td>
                                  <td style={{ border: "1px solid #000", padding: "8px" }}>
                                    Official Service partner / Organiser
                                  </td>
                                  <td style={{ border: "1px solid #000", padding: "8px" }}>
                                    During build-up
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </li>

                        <li>
                          <strong>49.3 Height Restrictions:</strong>
                          <ul style={{ listStyleType: "none" }}>
                            <li>
                              49.3.1	All Partitions and other display features have to be limited to a maximum height of 4.0 Meter including raised platform, if any. Partitions against the natural wall of the existing structures can be taken up to 5.0 Meter height.
                            </li>

                            <li>
                              49.3.2	Shell stalls: Height limit is 2.5 meters.
                            </li>

                            <li>
                              49.3.3	Product displays more than 4.0 meters in height can exceed these limits provided they are free standing directly on the floor and not on any elevated surface.
                            </li>

                            <li>
                              49.3.4	If constructing a Double Storey floor (applicable for Double Storey designated stalls only), the total stall height (including Double Storey) must not exceed 5 meters.
                            </li>

                            <li className="fw-semibold">
                              49.3.5	In case there is a difference in height of partition between 2 adjacent stalls and the height is within the maximum permissible height, the exposed portions of the partition with greater height (not exceeding 4.0 Meter in height) need to be finished with a neutral paint finish from the back side
                            </li>
                          </ul>
                        </li>
                      </ol>
                      <ol style={{ listStyleType: "none", paddingLeft: 0, marginLeft: 10 }}>
                        <li>
                          <strong>49.4 Stall Identification</strong>
                          <ul style={{ listStyleType: "none" }}>
                            <li>Display the stall number (minimum size: 2x2 feet) in a visible location.</li>
                          </ul>
                        </li>

                        <li className="mt-2">
                          <strong>49.5 Open Space Requirement</strong>
                          <ul style={{ listStyleType: "none" }}>
                            <li>Leave 70% of open sides along the aisle free of construction to improve visitor access and visibility.</li>
                          </ul>
                        </li>

                        <li className="mt-2">
                          <strong>49.6 Partition Walls Construction</strong>
                          <ul style={{ listStyleType: "none" }}>
                            <li>49.6.1	Organizers provide bare space with marked borders. Partition walls must be constructed by the exhibitor.</li>
                            <li>49.6.2	For partitions that are obstructive, clear glass/acrylic must be used above 1.2 meters.</li>
                          </ul>
                        </li>

                        <li className="mt-2">
                          <strong>49.7 Open-Sided Stalls</strong>
                          <ul style={{ listStyleType: "none" }}>
                            <li>Open sides should not be blocked with solid Partitions for more than 30% of the length of open side.</li>
                          </ul>
                        </li>

                        <li className="mt-2">
                          <strong>49.8 Back Walls</strong>
                          <ul style={{ listStyleType: "none" }}>
                            <li>Back wall is mandatory except for island stalls. The organizers reserve the right to ask exhibitors to modify any wall that exceeds the permitted height and blocks the view of neighbouring stalls.</li>
                          </ul>
                        </li>

                        <li className="mt-2">
                          <strong>49.9 Enclosures</strong>
                          <ul style={{ listStyleType: "none" }}>
                            <li>49.9.1	Offices, pantries, or conference enclosures:</li>
                            <li>49.9.2	Height: Max 4.0 meters.</li>
                            <li>49.9.3	Area: Max 30% of stall space.</li>
                          </ul>
                        </li>

                        <li className="mt-2">
                          <strong>49.10 Pillar Coverage</strong>
                          <ul style={{ listStyleType: "none" }}>
                            <li>Cover pillars up to 4.0 meters using panels, ensuring no damage. Provide a door for access to electrical supply or fire services, if applicable.</li>
                          </ul>
                        </li>

                        <li className="mt-2">
                          <strong>49.11 Logos &amp; Branding</strong>
                          <ul style={{ listStyleType: "none" }}>
                            <li>
                              Branding above 4 Meter height and up to 5.0 Meter height is allowed provided it is away from the adjacent stalls by at least 1 Meter, and no branding should overlook the neighbouring stalls and should face towards the Aisles only.
                            </li>
                          </ul>
                        </li>

                        <li className="mt-2">
                          <strong>49.12 Neighbouring Walls</strong>
                          <ul style={{ listStyleType: "none" }}>
                            <li>
                              Bare space exhibitors cannot display name boards on the back or side walls towards neighbouring stalls but can place them on any side facing the aisles.
                            </li>
                          </ul>
                        </li>

                        <li className="mt-2">
                          <strong>49.13 Accessibility</strong>
                          <ul style={{ listStyleType: "none" }}>
                            <li>
                              Raised platform may be constructed not exceeding 150mm in height. There should be at least one ramp of 1M x 1M provided in the raised platform for ease of access for Especially abled visitors. There should be no sharp edges of such raised platforms, and the corners need to be protected with Soft Corner Guards.
                            </li>
                          </ul>
                        </li>

                        <li className="mt-2">
                          <strong>49.14	Guidelines for Double Storey Floor Construction: </strong>

                          <ul style={{ listStyleType: "none" }}>
                            <li>49.14.1	The area of the Double Storey floor should not exceed 50% of the ground area booked..</li>
                            <li>49.14.2	Double Storey floor construction is allowed subject to following conditions:</li>
                            <li>49.14.3	Double Storey floor is permitted for Bare stalls above 72 Sq. Meters only and up to a maximum of 50% of the total area booked. Double Storey structure should be placed at least 1 Mt away from the adjacent stalls.</li>
                            <li>49.14.4	The Double Storey space will be charged at the bare space rate, calculated based the ground floor area, at the following rates (plus applicable taxes)<br></br>
                              Incase of {">="} 72 Sq.m stall upto 90 Sq.m 25%of the stall area permitted for upper storey.<br />
                              Incase of {">="} Sq.m stall 50% of the stall area can be constructed for upper storey.
                            </li>
                            <li>
                              <div className="fw-semibold">
                                Note: Allocation of the double storey space is subject to availability after the space allocation process is completed
                              </div>
                            </li>
                            <li>49.14.5	Minimum clear height below the Double Storey floor shall be 2.1 metres. </li>
                            <li>49.14.6	Double Storey floors with areas{">"} 100 sq.mtrs. must have two stairways – one for entry and one for exit. Such staircases must be placed separately and not next to each other for better escape route.</li>
                            <li>49.14.7	There should be a safety skirting of at least 100mm height all around the Double Storey floor and railing on top of it of maximum 1500mm height.</li>
                            <li>49.14.8	The width of the staircase should be minimum 1000mm, Riser should not exceed 175mm and Tread should be minimum 275mm.</li>
                            <li>49.14.9	Double Storey area is to be used for discussion/ meeting area purposes only and no display in the form of exhibits/ graphics or video walls is allowed on the Double Storey floor.</li>
                            <li>49.14.10	All structures should be designed for a Nut Bolt system of assembly and welding is not allowed at the venue.</li>
                            <li>49.14.11	All Double Storey structure designs need to be accompanied by a Structural Stability certificate duly stamped and signed by a Registered Structural Engineer clearly mentioning their registration number.</li>
                            <li>49.14.12	The construction of Double Storey floors are not allowed in Halls No. 1, 3, 5, and 7.</li>
                          </ul>
                        </li>

                        <li className="mt-2">
                          <strong><span class="highlight">49.15 Worker Rules</span></strong>
                          <ul style={{ listStyleType: "none" }}>
                            <li>Workers must be 18+ years and carry organizer-issued badges for hall access during construction and breakdown.</li>
                          </ul>
                        </li>

                        <li className="mt-2">
                          <strong><span class="highlight">49.16 Other Guidelines</span></strong>
                          <ul style={{ listStyleType: "none" }}>
                            <li>49.16.1	Exhibitors/ fabricators should try to use pre-fabricated structures to the maximum extent possible to enable faster installation and allow more time for the machinery movement and installation.</li>

                            <li>49.16.2	Artificial grass, grass carpets, creepers, plants, fur carpet, dry grass/leaves and any other materials/ items that pose fire hazard at site are prohibited irrespective of the approval for stand design submitted.</li>

                            <li>49.16.3	All wiring used in fabrication shall be of copper and use of Aluminium wiring is strictly prohibited.</li>

                            <li>49.16.4	All the workers working at a Pedestal or height must wear proper safety gear including Shoes, Helmet and safety belt.</li>
                          </ul>
                        </li>

                        <li className="mt-2">
                          <strong><span class="highlight">49.17 Important Points for Site Construction</span></strong>
                          <ul style={{ listStyleType: "none" }}>
                            <li>49.17.1	Use a carpet of the same size as the stand area to protect the venue flooring.</li>

                            <li>49.17.2	Maintain approved drawings, permissions, and have a responsible person onsite at all times.</li>

                            <li>49.17.3	All packing materials must be collected and placed at a designated corner for housekeeping. Littering will result in a penalty of ₹1000 per incident.</li>

                            <li className="fw-semibold"> 49.17.4 Contractor passes/wristbands are issued free of charge. Contractors must preserve their setup-day passes/wristbands for use during dismantling days. No fresh passes/wristbands will be issued for dismantling days.</li>
                          </ul>
                        </li>

                        <li className="mt-2">
                          <strong><span class="highlight">49.18 Electrical</span></strong>
                          <ul style={{ listStyleType: "none" }}>
                            <li>49.18.1	From point of power supply Only 3 Wires for Sigle Phase and 5 Wires for Three Phase are permissible from outgoing for internal distribution.</li>

                            <li>49.18.2	It is compulsory to internal distribution board inside the stall from exhibitor.</li>

                            <li>49.18.3	Exhibitors must submit their layout plan with the power supply point indicated.</li>
                          </ul>
                        </li>

                        <li className="mt-2">
                          <strong><span class="highlight">49.19	Mandatory Machine & Utility Marking Requirements:</span></strong>
                          <div style={{ width: "800px", marginTop: "10px" }}>
                            <table style={{ borderCollapse: "collapse" }}>
                              <thead>
                                <tr>
                                  <th style={{ background: 'none', border: "1px solid #000", padding: "8px", textAlign: "left", fontWeight: "bold" }}>Sr. No.</th>
                                  <th style={{ background: 'none', border: "1px solid #000", padding: "8px", textAlign: "left", fontWeight: "bold" }}>
                                    Requirement
                                  </th>
                                  <th style={{ background: 'none', border: "1px solid #000", padding: "8px", textAlign: "center", fontWeight: "bold" }}>
                                    Description
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td style={{ border: "1px solid #000", padding: "8px" }}>1</td>
                                  <td style={{ border: "1px solid #000", padding: "8px" }}>Machine Dimensions</td>
                                  <td style={{ border: "1px solid #000", padding: "8px" }}>
                                    Clearly indicate the length, width, and height of each machine/equipment.
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ border: "1px solid #000", padding: "8px" }}>2</td>
                                  <td style={{ border: "1px solid #000", padding: "8px" }}>Machine Placement</td>
                                  <td style={{ border: "1px solid #000", padding: "8px" }}>
                                    Show the exact location of each machine within the stall with dimensions.
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ border: "1px solid #000", padding: "8px" }}>3</td>
                                  <td style={{ border: "1px solid #000", padding: "8px" }}>Power Supply Points</td>
                                  <td style={{ border: "1px solid #000", padding: "8px" }}>
                                    Mark the required electrical connection point.
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ border: "1px solid #000", padding: "8px" }}>4</td>
                                  <td style={{ border: "1px solid #000", padding: "8px" }}>Compressed Air & Water Connection</td>
                                  <td style={{ border: "1px solid #000", padding: "8px" }}>
                                    Mark the required Compressed air & water connection point.
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </li>

                        <li className="mt-2">
                          <strong><span class="highlight">51.2 Third-Party Services:</span></strong>
                          <ul style={{ listStyleType: "none" }}>
                            <li>51.2.5 Non-Refundable Processing/Appointment Fee;</li>

                            <li>51.2.6 A one-time non-refundable fee of<strong> ₹ 3000 </strong>inclusive of GST is payable by Exhibitor/Vendor at the time of application/appointment.</li>
                          </ul>
                        </li>

                        <li className="mt-2">
                          <strong>35.7 Service partner Wristbands & Service Badges</strong>
                          <ul style={{ listStyleType: "none" }}>
                            <li>35.7.1 Each appointed stall Service partner will be issued up to 50 wristbands free of charge for access during the setup and dismantling period.
                            </li>
                            <li>35.7.2 Additional wristbands, if required, may be obtained at a charge of INR 50 per wristband.</li>
                            <li>35.7.3 Wristbands are non-transferable and must be worn at all times while inside the exhibition premises.
                            </li>
                          </ul>
                        </li>

                        <li className="mt-2">
                          <strong>35.7.4 Service Badges (Show Days):</strong>
                          <ul style={{ listStyleType: "none" }}>
                            <li>Each stall Service partner will be issued 5 Service Badges free of charge for access during the exhibition period.
                            </li>
                            <li>35.7.5 Additional Service Badges, if required, may be obtained at a charge of INR 300 per badge.</li>
                            <li>Service Badges are valid only for the approved Service partner personnel and are non-transferable.
                            </li>
                          </ul>
                        </li>

                        <li className="mt-2">
                          <strong><span class="highlight">Security Deposit</span></strong><br />
                          <span className="fw-semibold">This need to be deposited by the stall fabricator while completing the contractor registration formalities i.e. stall possession. The security deposit amount should be paid in DEMAND DRAFT ONLY and drawn in favour of ‘India ITME Society’. The same to be handed over to the officials of India ITME Society present on-site and to be collected from onsite post clearing the stall material materials.</span><br />

                          <i>(Please write the details with pencil on behind of demand draft like contracting Company Name, Contact Person, Mobile No.., along exhibiting company name, Mobile No Contact Person details)</i>
                        </li>
                        <div style={{ width: "800px", marginTop: "10px" }}>
                          <table style={{ borderCollapse: "collapse" }}>
                            <thead>
                              <tr>
                                <th style={{ border: "1px solid #000", padding: "8px", textAlign: "left", backgroundColor: "#d9c2b0", fontWeight: "bold" }}>
                                  Stall Size
                                </th>
                                <th style={{ border: "1px solid #000", padding: "8px", textAlign: "center", backgroundColor: "#d9c2b0", fontWeight: "bold" }}>
                                  Refundable Security Amount (Demand Draft Only)
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td style={{ border: "1px solid #000", padding: "8px" }}>Up to 50 m2</td>
                                <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center", fontWeight: "bold" }}>
                                  INR 15,000/-
                                </td>
                              </tr>
                              <tr>
                                <td style={{ border: "1px solid #000", padding: "8px" }}>51 m2 – 100 m2</td>
                                <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center", fontWeight: "bold" }}>
                                  INR 30,000/-
                                </td>
                              </tr>
                              <tr>
                                <td style={{ border: "1px solid #000", padding: "8px" }}>101 m2 – 150 m2</td>
                                <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center", fontWeight: "bold" }}>
                                  INR 50,000/-
                                </td>
                              </tr>
                              <tr>
                                <td style={{ border: "1px solid #000", padding: "8px" }}>151 m2 – 200 m2</td>
                                <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center", fontWeight: "bold" }}>
                                  INR 60,000/-
                                </td>
                              </tr>
                              <tr>
                                <td style={{ border: "1px solid #000", padding: "8px" }}>201 m2 – 500 m2</td>
                                <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center", fontWeight: "bold" }}>
                                  INR 80,000/-
                                </td>
                              </tr>
                              <tr>
                                <td style={{ border: "1px solid #000", padding: "8px" }}>501 m2 Above </td>
                                <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center", fontWeight: "bold" }}>
                                  INR 1,00,000/-
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <p className="text-center text-danger">Demand Draft Only accepted. No cheque or cash.</p>
                        </div>
                        <p className="fw-semibold mb-0">Deadline to Complete the work for {sessionStorage.getItem("ExhibitionName")}.</p>
                        <p className="mb-0">The deadline to complete the fabrication/touch up work of Raw / Bare Space (stand above 27 Sqm only) is only till <span className="fw-semibold mb-0">08:00 A.M of 03.12.2026 </span> post which it will attract penalty and uncompleted construction work will be halted. </p>

                        <p className="fw-semibold mb-0">It is Advised to bring pre-fabricated material as the venue being a pre-installed carpeted venue.</p>

                      </ol>

                    </div>
                  )}
                  {!isHideSection &&
                    <div class="card-header border-top" style={{ marginBottom: isCollapse ? '' : "15px" }}>
                      <h3 class="card-title" style={{ fontsize: "15px", marginRight: "15px" }}>
                        Electrical Guidelines
                      </h3>
                      <span
                        style={{ textDecoration: "underline", color: "blue", cursor: "pointer" }}
                        onClick={() => this.setState({ isCollapse: !isCollapse })}
                      >
                        click here to {isCollapse ? "hide" : "read"} Guidelines
                      </span>
                    </div>
                  }
                  {isCollapse && (
                    <div class="card-body p-1 m-2">
                      <div className="text-left mt-2">

                        <ol style={{ listStyleType: "none", paddingLeft: 0, marginLeft: 10 }}>
                          <li>
                            <strong>23.4 Power Tariffs & electrical guideline.</strong>
                            <ul style={{ listStyleType: "none" }}>
                              <li>
                                The exhibitor may indicate their power requirement and electrical guideline in the online exhibitor manual form which will be opened for confirmed exhibitor only.
                              </li>
                            </ul>

                            <strong>23. 5 Power Distribution</strong>
                            <ul style={{ listStyleType: "none" }}>
                              <li>
                                23.5.1 Exhibitors should note that 1kw supply/outlet is compulsory in every single stall as a facility for lighting. Every exhibitor must submit their layout plan with indication of point of power supply.
                              </li>
                              <li>23.5.2	The stall contractors undertaking lighting work shall possess valid electrical wireman license.</li>
                              <li>23.5.3	The load ≤ 3 kW shall be fed through single phase electrical supply at 230V AC ± 6 % and load {'>'} 3kW shall be fed through 3 Phase electrical Supply at 415V AC ± 6 % The supply Frequency will be 50Hz ± 3%. d.</li>
                              <li>23.5.4	From point of power supply Only 3 Wires for Sigle Phase and 5 Wires for Three Phase are permissible from outgoing for internal distribution.</li>
                              <li>23.5.5	It is compulsory to internal distribution board inside the stall from exhibitor.</li>
                              <li>23.5.6	The exhibitor requiring supply at voltage level other than above shall make necessary arrangement for the level matching equipment such as transformer, voltage stabilizer, inverter etc. to match the supply voltage level to their load.</li>
                              <li>23.5.7	The frame of stationary motor and the metallic parts, not intended as conductors, including transformers and any other apparatus used for regulating or controlling electricity of voltage exceeding 250V but not exceeding 650V shall be earthed firmly by the conductor size as mentioned.</li>
                              <li>23.5.8	Exhibitor are advised to make arrangement for power conditioning equipment such as UPS, CVT etc. for their critical & supply sensitive load/ equipment operating under very narrow band of tolerance.</li>
                              <li>23.5.9	The contractors shall use BIS marked PVC insulated 650/1100 V copper conductor wire for supplying electrical power to lighting & motive load to be installed in stall.</li>
                              <li>23.5.10	All switch boards shall conform to BIS & to Indian Electricity Act (amended).</li>
                              <li>23.5.10	All switch boards shall conform to BIS & to Indian Electricity Act (amended).</li>
                              <li>23.5.11	The insulation tape used shall carry IS marking.</li>
                              <li>23.5.12	For lighting circuit, the minimum wire size shall be 1.5/2.5 sq.mm PVC insulated 650V grade FRLS copper wire. For 16A power point, the minimum wire size shall be 4sq.mm PVC insulated 650V grade FRLS copper wire. The IR value of cable used shall not be less than 1MΩ when measured with 500V DC megger.</li>
                              <li>23.5.13	Exhibitor can bring international adopter for their internal electrical connection.</li>
                              <li>23.5.14	The contractor shall use following size of protective conductors for equipment at their stall from point of supply (MCB Box).</li>
                              <li>
                                <div style={{ width: "800px", marginTop: "10px" }}>
                                  <table style={{ borderCollapse: "collapse" }}>
                                    <thead>
                                      <tr>
                                        <th style={{ background: 'none', border: "1px solid #000", padding: "8px", textAlign: "left", fontWeight: "bold" }}>
                                          Size of phase conductor
                                        </th>
                                        <th style={{ background: 'none', border: "1px solid #000", padding: "8px", textAlign: "center", fontWeight: "bold" }}>
                                          Size of protective conductor of the same material as phase conductor
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td style={{ border: "1px solid #000", padding: "8px" }}>Up to 4mm²</td>
                                        <td style={{ border: "1px solid #000", padding: "8px" }}>
                                          Same size as that of phase conductor
                                        </td>
                                      </tr>
                                      <tr>
                                        <td style={{ border: "1px solid #000", padding: "8px" }}>Above 4mm² & up to 16mm²</td>
                                        <td style={{ border: "1px solid #000", padding: "8px" }}>
                                          Same size as that of phase conductor
                                        </td>
                                      </tr>
                                      <tr>
                                        <td style={{ border: "1px solid #000", padding: "8px" }}>Above 16mm² & up to 35mm²</td>
                                        <td style={{ border: "1px solid #000", padding: "8px" }}>
                                          16mm²
                                        </td>
                                      </tr>
                                      <tr>
                                        <td style={{ border: "1px solid #000", padding: "8px" }}>Above 35mm²</td>
                                        <td style={{ border: "1px solid #000", padding: "8px" }}>
                                          Half size of phase conductor
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </li>
                              <li>23.5.15	The earth wires shall be connected to the main earth firmly. After switching the entire load at stall, the voltage between neutral & earth shall not exceed 10V.</li>
                              <li>23.5.16	Exhibitor shall ensure that, the contractor shall carry out all electrical works in the stall area as per Indian Electricity Rules 2005/ CEA Regulation 2010/ General Specifications for Electrical Works, Part I & II by CPWD.</li>
                              <li>23.5.17	The Contractor shall carry out wiring at their installation as per IS-732:2010 with all safety precautions.</li>
                              <li>23.5.18	The load connected to power point shall be suitable for the socket and under no circumstances exceed the rated current capacity of the socket.</li>
                              <li>23.5.19	Exhibitors must install separate and independent MCBs/MCCBs/RCCBs of appropriated rating for their individual machines so as to automatically disconnect the supply in case of a) Overload b) Earth leakage or earth fault c) short circuit.</li>
                              <li>23.5.20	It is mandatory to use only reputed make wires like Polycom, KEI, Anchor etc and MCB/RCCB like Legrand, Siemens, ABB, Schneider for the electrical installation.</li>
                              <li>23.5.21	Wherever 3 ph connection is requested, the load shall be evenly distributed on all three phases. The current through neutral conductor or in other words, the current unbalance shall not exceed 5%.<br></br>
                                23.5.22	The contractor shall also ensure that conductor size of the cable/ wire is suitable to cater connected load without overloading/overheating in normal operation and during abnormal conditions. This may be checked and verified by electrical consultant.
                              </li>
                              <li>23.5.23	In case any material used by the contractor is found to be of inferior or sub-standard quality, the contractor shall be responsible for replacing the same without any loss of time as per the quality mutually agreed and mentioned above.</li>
                              <li>23.5.24	It is recommended to make use of low loss/ low heating choke manufactured as per IS and of reputed make namely Philips, Crompton, Bajaj, Wipro or equivalent.</li>
                              <li>23.5.25	The contractor shall control maximum 10 points or 800 watts whichever less, from single point.</li>
                              <li>23.5.26	Joint to the wires in any place is unacceptable. However, good quality connector of adequate rating properly covered cab be used.</li>
                              <li>23.5.27	Use 3-pin top / industrial to shall be made to take supply from sockets. The third pin shall be connected to earth through protective (loop earthing) conductor. It is strictly prohibited to insert wires directly into socket for drawing supply.</li>
                              <li>23.5.28	Adequate access to main power supply (relieving point) at stall shall be provided for cleaning & maintenance purpose. A clear space of not less than 1 meter shall be provided in front of the switchboard. Materials particularly combustible shall not be dumped at this location.</li>
                              <li>23.5.29	All main electrical supply points must be kept easily accessible for operation and repairs and for isolation of power in the event of emergency. These should not be concealed or covered under any circumstances.</li>
                              <li>23.5.30	Exhibitors requesting for 3-phase supply shall draw single phase power for lighting purpose from 3-phase supply outlet using double pole MCBs. The double pole MCB/RCCB shall be arranged by the exhibitor.</li>
                              <li>23.5.31	The electrical supply will be released only after completion of wiring work conforming to the Indian standards & codes of wiring and to the satisfaction of Electrical consultant.</li>
                              <li>23.5.32	UPS/Stabiliser with rating greater than 3kVA should have 3 Phase Input.</li>
                              <li>23.5.33	Point of power supply will be provided to below 15 kw.</li>
                              <li>23.5.34	Exhibitors may contact the Electrical Consultant at venue office for any technical queries.</li>
                              <li>23.5.35	Exhibitors under Shell Scheme package would be provided with a plug point socket and a switch for a 230 V, 6 Amp A.C. supply. Consumption of power through this plug point for the connected load upto 1 kw is included in the cost of shell scheme package. However, additional power would be made available to them on extra payment.</li>
                              <li>23.5.36	Exhibitors shall bring their own electrical cables, wires, sockets, international electrical adaptor to connect their electrical installation.</li>
                              <li>23.5.37	The Exhibition authority arrange for supply of power will be entrusted with the authority for regulating and controlling the power supply to the exhibition halls and individual stalls.</li>
                            </ul>

                            <strong>23.6	Electrical Installation Regulations</strong>
                            <ul style={{ listStyleType: "none" }}>
                              <li>
                                23.6.1	Electrical wiring and installation must be done by Exhibitors through registered professional technicians using proper wiring, switches etc. so as to ensure safety. The Organisers shall not be responsible or liable in case of any mishap due to use of sub-standard material or unskilled labour.
                              </li>
                              <li>23.6.2	Lamps and appliances with high temperature surfaces should be guarded and used well away from combustible materials.</li>
                              <li>23.6.3	No light fitting or other appliance may be suspended from the roof of the exhibition hall.</li>
                              <li>23.6.4	Exhibitors are requested to review their internal wiring and connections thoroughly before going live. Also, Members should estimate the power requirement in advance so that, appropriate load management can be done. Switching from temporary to permanent power supply should be done in advance clear two days, so that testing and balancing can be done properly.</li>
                              <li>23.6.5	Exhibitor shall submit Electrical Work Completion Report to Hall Directors for permanent power connection as per the format. Power will be released on receipt of the completion report.</li>
                              <li>23.6.6	The Organisers reserve the right to disconnect any installation, which in their opinion is dangerous or likely to cause annoyance to visitors or other Exhibitors.</li>
                              <li>23.6.7	In order to take care of voltage fluctuations, the Exhibitors are advised to fix up constant voltage transformers or insulation Transformer or stabilizers for CNC and other sensitive machines. Exhibitors are encouraged to use MCCB wherever necessary. The main supply points and electrical installations in the stand should be kept open for easy access and should not be concealed.</li>
                              <li>23.6.8	Electrical power should be drawn from designated points allocated to the exhibitor only. Any exhibitor or its designated contractor found drawing power from unauthorized sources will be liable to forfeiter of security deposit and or in the event of non-compliance with the applicable Rules and Regulations, the corresponding onsite charges, penalties, recovery costs, or any other applicable fees shall be levied and recovered from the concerned party. Such charges shall be determined in accordance with the provisions of these Rules and Regulations and the applicable schedule of charges. In the event of any unauthorized usage, encroachment, modification, or non-compliance related to space utilization, the applicable penalty and recovery charges shall be imposed in accordance with Clause 18.3 of the Rules and Regulations and shall be recovered from the concerned party.</li>
                            </ul>
                          </li>
                        </ol>
                      </div>
                    </div>
                  )}
                  <p style={{ margin: "0 0 0 10px" }}>
                    <span className="fw-semibold">Exhibitor Details:</span>
                  </p>
                  <div className="row m-0">
                    <div className="col-md-6 col-lg-4 mb-3">
                      <label>Exhibitor Name</label>
                      <input
                        type="text"
                        className="form-control"
                        value={ExhibitorName}
                        disabled={true}
                      />
                    </div>
                    <div className="col-md-6 col-lg-4 mb-3">
                      <label htmlFor="validationCustom03">Stall No</label>
                      <input
                        type="text"
                        className="form-control"
                        value={StallName}
                        disabled={true}
                      />
                    </div>
                    <div className="col-md-6 col-lg-4 mb-3">
                      <label htmlFor="validationCustom03">Hall Name</label>
                      <input
                        type="text"
                        className="form-control"
                        value={HallName}
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className="row m-0">
                    <div className="col-md-6 col-lg-4 mb-3">
                      <label>Open Sides</label>
                      <input
                        type="text"
                        className="form-control"
                        value={OpenSides}
                        disabled={true}
                      />
                    </div>
                    <div className="col-md-6 col-lg-4 mb-3">
                      <label htmlFor="validationCustom03">Area</label>
                      <input
                        type="text"
                        className="form-control"
                        value={StallArea}
                        disabled={true}
                      />
                    </div>
                    <div className="col-md-6 col-lg-4 mb-3">
                      <label htmlFor="validationCustom03">Stall Type</label>
                      <input
                        type="text"
                        className="form-control"
                        value={StallTypeName}
                        disabled={true}
                      />
                    </div>
                  </div>

                  <p style={{ margin: "0 0 0 10px" }}>
                    <span className="fw-semibold">Contractor Details:</span>
                  </p>
                  <div className="row m-0">
                    <div className="col-md-6 col-lg-4 mb-3">
                      <label>Company Name</label>
                      <input
                        className="form-control"
                        value={CompanyName}
                        disabled={true}
                        onChange={(e) =>
                          !isDeadlinePassed &&
                          this.setState({
                            CompanyName: e.target.value,
                            CompanyNameErr: "",
                          })
                        }
                        maxLength={100}
                        type="text"
                      />
                      {
                        <span className="text-danger text-start text-left d-block mt-1">
                          {CompanyNameErr}
                        </span>
                      }
                    </div>
                    <div className="col-md-6 col-lg-4 mb-3">
                      <label >Person Name</label>
                      <input
                        className="form-control"
                        value={PersonName}
                        disabled={true}
                        onChange={(e) =>
                          !isDeadlinePassed &&
                          this.setState({
                            PersonName: e.target.value,
                            PersonNameErr: "",
                          })
                        }
                        maxLength={70}
                        type="text"
                      />
                      {
                        <span className="text-danger text-start text-left d-block mt-1">
                          {PersonNameErr}
                        </span>
                      }
                    </div>
                    <div className="col-md-6 col-lg-4 mb-3">
                      <label>Email</label>
                      <input
                        className="form-control"
                        value={Email}
                        disabled={true}
                        onChange={(e) =>
                          !isDeadlinePassed &&
                          this.setState({ Email: e.target.value, EmailErr: "" })
                        }
                        maxLength={100}
                        type="text"
                      />
                      {
                        <span className="text-danger text-start text-left d-block mt-1">
                          {EmailErr}
                        </span>
                      }
                    </div>
                    <div className="col-md-6 col-lg-4 mb-3">
                      <label >Mobile No</label>
                      <input
                        className="form-control"
                        value={Mobile}
                        disabled={true}
                        onChange={(e) =>
                          !isDeadlinePassed &&
                          this.setState({
                            Mobile: e.target.value.replace(/\D/, ""),
                            MobileErr: "",
                          })
                        }
                        maxLength={sessionStorage.getItem("CurrencyID") == 1 ? 10 : 20}
                        type="text"
                      />
                      {
                        <span className="text-danger text-start text-left d-block mt-1">
                          {MobileErr}
                        </span>
                      }
                    </div>
                  </div>

                  <p style={{ margin: "0 0 0 10px" }}>
                    <span className="fw-semibold">No. of Passes/Bands:</span>
                  </p>
                  <div className="row m-0">
                    <div className="col-md-6 col-lg-4 mb-3">
                      <label >Required for setup days<span className="required">*</span></label>
                      <input
                        className="form-control"
                        value={SetUpDayPasses}
                        disabled={is_View || isDeadlinePassed || StatusID == 2}
                        onChange={(e) =>
                          !isDeadlinePassed &&
                          this.setState({
                            SetUpDayPasses: e.target.value.replace(/\D/, ""),
                            SetUpDayPassesErr: "",
                          })
                        }
                        maxLength={20}
                        type="text"
                      />
                      {
                        <span className="text-danger text-start text-left d-block mt-1">
                          {SetUpDayPassesErr}
                        </span>
                      }
                    </div>
                    <div className="col-md-6 col-lg-4 mb-3">
                      <label >Required for dismantle days<span className="required">*</span></label>
                      <input
                        className="form-control"
                        value={DismantleDayPasses}
                        disabled={is_View || isDeadlinePassed || StatusID == 2}
                        onChange={(e) =>
                          !isDeadlinePassed &&
                          this.setState({
                            DismantleDayPasses: e.target.value.replace(/\D/, ""),
                            DismantleDayPassesErr: "",
                          })
                        }
                        maxLength={20}
                        type="text"
                      />
                      {
                        <span className="text-danger text-start text-left d-block mt-1">
                          {DismantleDayPassesErr}
                        </span>
                      }
                    </div>
                  </div>

                  <div className="row m-3">
                    <div className="col-xl-3 col-lg-3 col-md-6 col-12 mb-4 px-2">
                      <div className="h-100" style={{ border: "1px solid #c9c4c4", borderRadius: "5px", overflow: "hidden" }}>
                        <p
                          style={{
                            padding: "15px",
                            background: "#e3e2e2",
                            textAlign: "center",
                          }}
                        >
                          {" "}
                          <span className="fw-semibold">
                            Floor Plan<span className="required">*</span>
                          </span>{" "}
                        </p>
                        <img
                          title=""
                          // src={`${url}${data.CateringImage}#toolbar=0&navpanes=0`}
                          src={`${displayfile_1}#toolbar=0&navpanes=0`}
                          // src='https://ems_uat.india-itme.com/document/Circular/10/Circular_10.pdf#toolbar=0&navpanes=0'
                          style={{ padding: '0px 20px', height: "270px", cursor: "pointer" }}
                          id="myIframe"
                          onClick={(e) => fileName_1 != '' && this.showImage("file_1", "Floor Plan")}
                        />
                        {/* <div
                        className="viewImageIframe"
                        onClick={(e) => this.showImage("file_1", "Floor Plan")}
                      /> */}
                        <div className="mb-2">
                          {fileName_1 != "" ? (
                            <>
                              <div className="d-flex" style={{ justifyContent: "center" }}>
                                <div className="chooseStallFile">
                                  <p className="overflow-membership m-0">{fileName_1}</p>
                                  {!isDeadlinePassed && !is_View && (
                                    <span
                                      className="membership_file_cross text-danger"
                                      onClick={(e) =>
                                        this.removeFile(e, "file_1")
                                      }
                                    >
                                      X
                                    </span>
                                  )}
                                </div>
                              </div>
                            </>
                          ) : (
                            <div className="d-flex" style={{ justifyContent: "center" }}>
                              <input
                                type="file"
                                accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                                className="form-control mt-2"
                                style={{ width: "80%" }}
                                onChange={(e) => this.onFilePick(e, e.target.files, "file_1")}
                              />
                            </div>
                          )}
                          <p
                            className="text-aqua"
                            style={{ margin: "6px", textAlign: "center" }}
                          >
                            (Only .jpg, .jpeg, .png formats are allowed with maximum size of 3MB)
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-6 col-12 mb-4 px-2">
                      <div className="h-100" style={{ border: "1px solid #c9c4c4", borderRadius: "5px", overflow: "hidden" }}>
                        <p
                          style={{
                            padding: "15px",
                            background: "#e3e2e2",
                            textAlign: "center",
                          }}
                        >
                          {" "}
                          <span className="fw-semibold">
                            Front Elevation<span className="required">*</span>
                          </span>
                        </p>
                        <img
                          title=""
                          src={`${displayfile_3}#toolbar=0&navpanes=0`}
                          style={{ padding: '0px 20px', height: "270px", cursor: "pointer" }}
                          id="myIframe"
                          onClick={(e) => fileName_3 != '' && this.showImage("file_3", "Front Elevation")}
                        />
                        <div className="mb-2">
                          {fileName_3 != "" ? (
                            <>
                              <div className="d-flex" style={{ justifyContent: "center" }}>
                                <div className="chooseStallFile">
                                  <p className="overflow-membership m-0">{fileName_3}</p>
                                  {!isDeadlinePassed && !is_View && (
                                    <span
                                      className="membership_file_cross text-danger"
                                      onClick={(e) =>
                                        this.removeFile(e, "file_3")
                                      }
                                    >
                                      X
                                    </span>
                                  )}
                                </div>
                              </div>
                            </>
                          ) : (
                            <div className="d-flex" style={{ justifyContent: "center" }}>
                              <input
                                type="file"
                                accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                                className="form-control mt-2"
                                style={{ width: "80%" }}
                                onChange={(e) => this.onFilePick(e, e.target.files, "file_3")}
                              />
                            </div>
                          )}
                          <p
                            className="text-aqua"
                            style={{ margin: "6px", textAlign: "center" }}
                          >
                            (Only .jpg, .jpeg, .png formats are allowed with maximum size of 3MB)
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="col-xl-3 col-lg-3 col-md-6 col-12 mb-4 px-2">
                      <div className="h-100" style={{ border: "1px solid #c9c4c4", borderRadius: "5px", overflow: "hidden" }}>
                        <p
                          style={{
                            padding: "15px",
                            background: "#e3e2e2",
                            textAlign: "center",
                          }}
                        >
                          {" "}
                          <span className="fw-semibold">
                            Side Elevation<span className="required">*</span>
                          </span>
                        </p>
                        <img
                          title=""
                          src={`${displayfile_4}#toolbar=0&navpanes=0`}
                          style={{ padding: '0px 20px', height: "270px", cursor: "pointer" }}
                          id="myIframe"
                          onClick={(e) => fileName_4 != '' && this.showImage("file_4", "Side Elevation")}
                        />
                        <div className="mb-2">
                          {fileName_4 != "" ? (
                            <>
                              <div className="d-flex" style={{ justifyContent: "center" }}>
                                <div className="chooseStallFile">
                                  <p className="overflow-membership m-0">{fileName_4}</p>
                                  {!isDeadlinePassed && !is_View && (
                                    <span
                                      className="membership_file_cross text-danger"
                                      onClick={(e) =>
                                        this.removeFile(e, "file_4")
                                      }
                                    >
                                      X
                                    </span>
                                  )}
                                </div>
                              </div>
                            </>
                          ) : (
                            <div className="d-flex" style={{ justifyContent: "center" }}>
                              <input
                                type="file"
                                accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                                className="form-control mt-2"
                                style={{ width: "80%" }}
                                onChange={(e) => this.onFilePick(e, e.target.files, "file_4")}
                              />
                            </div>
                          )}
                          <p
                            className="text-aqua"
                            style={{ margin: "6px", textAlign: "center" }}
                          >
                            (Only .jpg, .jpeg, .png formats are allowed with maximum size of 3MB)
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-6 col-12 mb-4 px-2">
                      <div className="h-100" style={{ border: "1px solid #c9c4c4", borderRadius: "5px", overflow: "hidden" }}>
                        <p
                          style={{
                            padding: "15px",
                            background: "#e3e2e2",
                            textAlign: "center",
                          }}
                        >
                          {" "}
                          <span className="fw-semibold">
                            3D View<span className="required">*</span>
                          </span>
                        </p>
                        <img
                          title=""
                          src={`${displayfile_2}#toolbar=0&navpanes=0`}
                          style={{ padding: '0px 20px', height: "270px", cursor: "pointer" }}
                          id="myIframe"
                          onClick={(e) => fileName_2 != '' && this.showImage("file_2", "3D View")}
                        />
                        <div className="mb-2">
                          {fileName_2 != "" ? (
                            <>
                              <div className="d-flex" style={{ justifyContent: "center" }}>
                                <div className="chooseStallFile">
                                  <p className="overflow-membership m-0">{fileName_2}</p>
                                  {!isDeadlinePassed && !is_View && (
                                    <span
                                      className="membership_file_cross text-danger"
                                      onClick={(e) =>
                                        this.removeFile(e, "file_2")
                                      }
                                    >
                                      X
                                    </span>
                                  )}
                                </div>
                              </div>
                            </>
                          ) : (
                            <div className="d-flex" style={{ justifyContent: "center" }}>
                              <input
                                type="file"
                                accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                                className="form-control mt-2"
                                style={{ width: "80%" }}
                                onChange={(e) => this.onFilePick(e, e.target.files, "file_2")}
                              />
                            </div>
                          )}
                          <p
                            className="text-aqua"
                            style={{ margin: "6px", textAlign: "center" }}
                          >
                            (Only .jpg, .jpeg, .png formats are allowed with maximum size of 3MB)
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row m-3">
                    <div className="col-xl-3 col-lg-3 col-md-6 col-12 mb-4 px-2">
                      <div className="h-100" style={{ border: "1px solid #c9c4c4", borderRadius: "5px", overflow: "hidden" }}>
                        <p
                          style={{
                            padding: "15px",
                            background: "#e3e2e2",
                            textAlign: "center",
                          }}
                        >
                          {" "}
                          <span className="fw-semibold">
                            Technical layout placement of utilities (Power, Water, and Air)<span className="required">*</span>
                          </span>
                        </p>
                        <img
                          title=""
                          src={`${displayfile_7}#toolbar=0&navpanes=0`}
                          style={{ padding: '0px 20px', height: "270px", cursor: "pointer" }}
                          id="myIframe"
                          onClick={(e) => fileName_7 != '' && this.showImage("file_7", "TechnicalLayout")}
                        />
                        <div className="mb-2">
                          {fileName_7 != "" ? (
                            <>
                              <div className="d-flex" style={{ justifyContent: "center" }}>
                                <div className="chooseStallFile">
                                  <p className="overflow-membership m-0">{fileName_7}</p>
                                  {!isDeadlinePassed && !is_View && (
                                    <span
                                      className="membership_file_cross text-danger"
                                      onClick={(e) =>
                                        this.removeFile(e, "file_7")
                                      }
                                    >
                                      X
                                    </span>
                                  )}
                                </div>
                              </div>
                            </>
                          ) : (
                            <div className="d-flex" style={{ justifyContent: "center" }}>
                              <input
                                type="file"
                                accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                                className="form-control mt-2"
                                style={{ width: "80%" }}
                                onChange={(e) => this.onFilePick(e, e.target.files, "file_7")}
                              />
                            </div>
                          )}
                          <p
                            className="text-aqua"
                            style={{ margin: "6px", textAlign: "center" }}
                          >
                            (Only .jpg, .jpeg, .png formats are allowed with maximum size of 3MB)
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-6 col-12 mb-4 px-2">
                      <div className="h-100" style={{ border: "1px solid #c9c4c4", borderRadius: "5px", overflow: "hidden" }}>
                        <p
                          style={{
                            padding: "15px",
                            background: "#e3e2e2",
                            textAlign: "center",
                          }}
                        >
                          {" "}
                          <span className="fw-semibold">
                            Structural certificates from certified Engineer (Applicable for double
                            story stall){" "}
                          </span>
                        </p>
                        {/* <img
                        title=""
                        src={`${fileName_5 != '' ? displayfile_5 : ''}#toolbar=0&navpanes=0`}
                        style={{ padding:'0px 20px', height: "270px", cursor: "pointer" }}
                        onClick={(e) => fileName_5 != '' &&
                          this.showImage(
                            "file_5",
                            "Structural certificates from certified Engineer"
                          )
                        }
                      /> */}
                        <img
                          title=""
                          src={`${fileName_5 != '' ? displayfile_5 : ''}#toolbar=0&navpanes=0`}
                          style={{ padding: '0px 20px', height: "270px", cursor: "pointer" }}
                          id="myIframe"
                          onClick={(e) => fileName_5 != '' &&
                            this.showImage(
                              "file_5",
                              "Structural certificates from certified Engineer"
                            )
                          }
                        />
                        <div className="mb-2">
                          {fileName_5 != "" ? (
                            <>
                              <div className="d-flex" style={{ justifyContent: "center" }}>
                                <div className="chooseStallFile">
                                  <p className="overflow-membership m-0">{fileName_5}</p>
                                  {!isDeadlinePassed &&
                                    !is_View && (
                                      <span
                                        className="membership_file_cross text-danger"
                                        onClick={(e) =>
                                          this.removeFile(e, "file_5")
                                        }
                                      >
                                        X
                                      </span>
                                    )}
                                </div>
                              </div>
                            </>
                          ) : (
                            <div className="d-flex" style={{ justifyContent: "center" }}>
                              <input
                                type="file"
                                accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                                className="form-control mt-2"
                                style={{ width: "80%" }}
                                onChange={(e) => this.onFilePick(e, e.target.files, "file_5")}
                                disabled={is_View || isDeadlinePassed}
                              />
                            </div>
                          )}
                          <p
                            className="text-aqua"
                            style={{ margin: "6px", textAlign: "center" }}
                          >
                            (Only .jpg, .jpeg, .png formats are allowed with maximum size of 3MB)
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-6 col-12 mb-4 px-2">
                      <div className="h-100" style={{ border: "1px solid #c9c4c4", borderRadius: "5px", overflow: "hidden" }}>
                        <p
                          style={{
                            padding: "15px",
                            background: "#e3e2e2",
                            textAlign: "center",
                          }}
                        >
                          <span className="fw-semibold">
                            {" "}
                            Fire safety certificates from certified Engineer (Applicable for
                            double story stall){" "}
                          </span>
                        </p>
                        <img
                          title=""
                          src={`${fileName_6 != '' ? displayfile_6 : ''}#toolbar=0&navpanes=0`}
                          style={{ padding: '0px 20px', height: "270px", cursor: "pointer" }}
                          id="myIframe"
                          onClick={(e) => fileName_6 != '' &&
                            this.showImage(
                              "file_6",
                              "Fire safety certificates from certified Engineer"
                            )
                          }
                        />
                        <div className="mb-2">
                          {fileName_6 != "" ? (
                            <>
                              <div className="d-flex" style={{ justifyContent: "center" }}>
                                <div className="chooseStallFile">
                                  <p className="overflow-membership m-0">{fileName_6}</p>
                                  {!isDeadlinePassed && (
                                    <span
                                      className="membership_file_cross text-danger"
                                      onClick={(e) =>
                                        !is_View ? this.removeFile(e, "file_6") : ""
                                      }
                                    >
                                      X
                                    </span>
                                  )}
                                </div>
                              </div>
                            </>
                          ) : (
                            <div className="d-flex" style={{ justifyContent: "center" }}>
                              <input
                                type="file"
                                accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                                className="form-control mt-2"
                                style={{ width: "80%" }}
                                disabled={is_View || isDeadlinePassed}
                                onChange={(e) => this.onFilePick(e, e.target.files, "file_6")}
                              />
                              {/* <span className="text-danger" style={{ fontSize: '12px', textAlign: 'center', display: 'block' }}>
                                                        Max 3MB | Image formats only
                                                    </span> */}
                            </div>
                          )}
                          <p
                            className="text-aqua"
                            style={{ margin: "6px", textAlign: "center" }}
                          >
                            (Only .jpg, .jpeg, .png formats are allowed with maximum size of 3MB)
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row m-1">
                    <form>
                      <span className="fw-semibold">
                        {" "}
                        <label>Remark</label>
                      </span>
                      <textarea
                        class="form-control"
                        value={Remark}
                        onChange={(e) => this.setState({ Remark: e.target.value })}
                        maxLength={300}
                        disabled={is_View || isDeadlinePassed}
                        rows="3"
                      ></textarea>


                      {!isHideSection && (
                        <label class="d-flex mt-4">
                          <input
                            type="checkbox"
                            checked={Is_Agree}
                            disabled={is_View || isDeadlinePassed || StatusID == 2}
                            onChange={(e) =>
                              !isDeadlinePassed &&
                              this.setState({ Is_Agree: e.target.checked, Is_AgreeErr: "" })
                            }
                          />
                          <span className="fw-semibold">
                            I agree to the above-mentioned stall Design and electrical guidelines of {sessionStorage.getItem("ExhibitionName")}
                            <span className="required">*</span>.
                          </span>
                        </label>
                      )}
                      {
                        <span className="text-danger text-start text-left d-block mt-1">
                          {Is_AgreeErr}
                        </span>
                      }
                    </form>
                  </div>

                  <div class="d-flex m-3">
                    {!is_View ? (
                      <button type="button"
                        className="btn btn-aqua rounded-1 d-block mt-3 mb-3 mx-2"
                        onClick={() => this.setState({ isOpenConfirmationModal: true })}
                      >{this.state.StatusID == 0 ? "Submit" : "Update"}</button>
                    ) : (
                      <></>
                    )}
                    {!isHideSection && <button
                      className="btn rounded-0 d-block mt-3 mb-3 btn-gray"
                      onClick={() => this.handleCancel()}
                    >
                      Back
                    </button>}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <Modal
          isOpen={isOpenConfirmationModal}
          onRequestClose={() => this.setState({ isOpenConfirmationModal: false })}
          shouldCloseOnEsc={true}
          shouldCloseOnOverlayClick={true}
          ariaHideApp={false}
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header text-white p-2">
                <h6 className="modal-title fw-normal">Do you want to {this.state.StatusID == 0 ? "Submit" : "Update"} ?</h6>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => this.setState({ isOpenConfirmationModal: false })}
                />
              </div>

              <div className="modal-body">
                <p>I acknowledge that the submitted stall design complies with the Organizer's Stall Design Guidelines and venue regulations.</p>
              </div>


              <div className="modal-footer">
                <button type="button" className="btn btn-aqua"
                  onClick={() => this.handleSubmit()}
                >{this.state.StatusID == 0 ? "Submit" : "Update"}</button>
                <button
                  className="btn btn-gray"
                  onClick={() => this.setState({ isOpenConfirmationModal: false })}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={isOpen}
          onRequestClose={() => this.setState({ isOpen: false })}
          shouldCloseOnEsc={true}
          shouldCloseOnOverlayClick={true}
          ariaHideApp={false}
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header text-white p-2">
                <h6 className="modal-title fw-normal">{modalImageName}</h6>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => this.setState({ isOpen: false })}
                />
              </div>

              <div className="modal-body">
                <img
                  title=""
                  // src={`${url}${data.CateringImage}#toolbar=0&navpanes=0`}
                  src={`${modalImagePath}#toolbar=0&navpanes=0`}
                // src='https://ems_uat.india-itme.com/document/Circular/10/Circular_10.pdf#toolbar=0&navpanes=0'
                // style={{ width: "905px", height: "550px" }}
                // id="myIframe"
                />
              </div>


              <div className="modal-footer">
                <button
                  className="btn btn-gray"
                  onClick={() => this.setState({ isOpen: false })}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </Modal>

        {/* <Modal isOpen={isOpen} onHide={() => this.setState({ isOpen: false })} size="xl" style={{ zIndex: '99999' }}>
          <Modal.Header>
            <Modal.Title> {modalImageName}</Modal.Title>
            <span
              onClick={() => this.setState({ isOpen: false })}
              style={{ cursor: "pointer", fontWeight: "800" }}
            >
              X
            </span>
          </Modal.Header>

          <Modal.Body style={{ marginBottom: "0px", textAlign: "center" }}>
            <img
              title=""
              // src={`${url}${data.CateringImage}#toolbar=0&navpanes=0`}
              src={`${modalImagePath}#toolbar=0&navpanes=0`}
            // src='https://ems_uat.india-itme.com/document/Circular/10/Circular_10.pdf#toolbar=0&navpanes=0'
            // style={{ width: "905px", height: "550px" }}
            // id="myIframe"
            />
          </Modal.Body>
        </Modal> */}

      </>
    );
  }
}
export default withRouter(connect(null, {
  getStallDesignDetails_action, insertUpdateStallDesign_action, insertUpdateExhibitorContractorBadgeApplication_action,
  getExhibitorContractorBadgeApplicationDetails_action,
})(StallDesign))